<template>
    <div class="debug-filters">
        <app-select
            v-model="selectedCity"
            :options="citiesOptions"
            placeholder="Выберите город"
            class="debug-filters__filter"
        />
        <app-select
            v-if="selectedCity"
            v-model="selectedServiceArea"
            :options="cityServiceAreasOptions"
            placeholder="Выберите зону"
            class="debug-filters__filter"
        />
        <button
            v-if="selectedServiceArea"
            class="button button_dark debug-filters__reset"
            @click="reset"
        >
            Сбросить
        </button>
    </div>
</template>

<script>
import AppSelect from'./AppSelect';

export default {
    components: {
        AppSelect,
    },
    props: {
        serviceAreas: {
            type: Object,
            required: true,
            default: () => ({})
        },
        ymap: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedCity: null,
            selectedServiceArea: null
        };
    },
    computed: {
        citiesOptions() {
            return Object.keys(this.serviceAreas).map((cityName) => ({ text: cityName, value: cityName }));
        },
        cityServiceAreasOptions() {
            const cityAreas = this.serviceAreas[this.selectedCity].serviceAreas || [];
            return cityAreas.map((serviceArea, index) => ({ text: `Зона ${index + 1} (${serviceArea.id})`, value: serviceArea }));
        },
        allPolygons() {
            const result = {};

            Object.keys(this.serviceAreas).forEach((cityName) => {
                const cityServiceAreas = this.serviceAreas[cityName].serviceAreas;

                cityServiceAreas.forEach((serviceArea) => {
                    const { id: serviceAreaId, include, exclude } = serviceArea;
                    const allGeoObjects = (exclude) ? [...include, ...exclude] : include;

                    allGeoObjects.forEach((geoObject) => {
                        if (geoObject.type === 'polygon') {
                            if (!result[cityName]) {
                                result[cityName] = {};
                            }

                            if (!result[cityName][serviceAreaId]) {
                                result[cityName][serviceAreaId] = [];
                            }

                            result[cityName][serviceAreaId].push(...geoObject.ymapPolygons);
                        }
                    });
                });
            });

            return result;
        },
    },
    watch: {
        selectedCity() {
            this.selectedServiceArea = null;
        },
        selectedServiceArea(serviceArea) {
            if (serviceArea) {
                this.showServiceArea(this.selectedCity, serviceArea);
            } else {
                this.showAllPolygons();
            }
        }
    },
    methods: {
        reset() {
            this.selectedCity = null;
            this.selectedServiceArea = null;
            this.showAllPolygons();
        },
        showServiceArea(cityName, serviceArea) {
            this.hideAllPolygons();
            this.showServiceAreaPolygons(cityName, serviceArea);
            // @todo: центрирование карты
        },
        hideAllPolygons() {
            Object.keys(this.allPolygons).forEach((cityName) => {
                Object.keys(this.allPolygons[cityName]).forEach((serviceAreaId) => {
                    const serviceAreaPolygons = this.allPolygons[cityName][serviceAreaId];
                    serviceAreaPolygons.forEach((ymapPolygon) => ymapPolygon.options.set('visible', false));
                });
            });
        },
        showAllPolygons() {
            Object.keys(this.allPolygons).forEach((cityName) => {
                Object.keys(this.allPolygons[cityName]).forEach((serviceAreaId) => {
                    const serviceAreaPolygons = this.allPolygons[cityName][serviceAreaId];
                    serviceAreaPolygons.forEach((ymapPolygon) => ymapPolygon.options.set('visible', true));
                });
            });
        },
        showServiceAreaPolygons(cityName, serviceArea) {
            const serviceAreaPolygons = this.allPolygons[cityName][serviceArea.id];
            serviceAreaPolygons.forEach((ymapPolygon) => ymapPolygon.options.set('visible', true))
        }
    }
};
</script>

<style lang="scss">
$b: '.debug-filters';

#{$b} {
    display: flex;
    margin-bottom: 30px;

    &__filter {
        width: 250px;

        &:not(:last-child) {
            margin-right: 10px;
        }
    }

    &__reset {
        height: 40px;
        line-height: 40px;
        border-radius: 10px;
    }
}
</style>
